/* unplugin-vue-components disabled */import script from "./PostBoxRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostBoxRow.vue?vue&type=script&setup=true&lang=ts"

import "./PostBoxRow.vue?vue&type=style&index=0&id=2ea1f31c&lang=scss&scoped=true"
import "./PostBoxRow.vue?vue&type=style&index=1&id=2ea1f31c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea1f31c"]])

export default __exports__